import { render, staticRenderFns } from "./BulkProductEdit.vue?vue&type=template&id=2c042b27&"
import script from "./BulkProductEdit.vue?vue&type=script&lang=js&"
export * from "./BulkProductEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/BulkProductEdit.vue
// module id = null
// module chunks = 